import { render, staticRenderFns } from "./uCatalogue.vue?vue&type=template&id=1752183a&scoped=true&"
import script from "./uCatalogue.vue?vue&type=script&lang=js&"
export * from "./uCatalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1752183a",
  null
  
)

export default component.exports